import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, CheckCircle2 } from "lucide-react";
import { subscribeJob, subscribeDriverStops, STOP_STATUS_META } from "../lib/deliveries";
import { useAuth } from "../context/AuthContext";

export default function DriverJobStops() {
  const { jobId } = useParams();
  const { user } = useAuth();
  const [job, setJob] = useState(null);
  const [stops, setStops] = useState([]);
  useEffect(() => {
    const u1 = subscribeJob(jobId, setJob);
    const u2 = subscribeDriverStops(user?.email, (all) => setStops(all.filter((s) => s.job_id === jobId).sort((a, b) => a.stop_number - b.stop_number)));
    return () => { u1(); u2 && u2(); };
  }, [jobId, user]);
  if (!job) return <div className="p-16 text-center text-slate-500">Loading…</div>;

  return (
    <div className="bg-slate-50 min-h-screen pb-10">
      <section className="bg-[#0f2847] text-white stripe-bg sticky top-0 z-10">
        <div className="container-518 py-5">
          <Link to="/driver/deliveries" className="inline-flex items-center gap-2 text-xs text-slate-300 mb-2"><ArrowLeft className="w-4 h-4" /> My routes</Link>
          <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#f59321]">{job.job_reference}</div>
          <h1 className="font-display text-xl font-extrabold">{job.job_name}</h1>
          <div className="mt-3 flex items-center gap-3">
            <div className="flex-1 h-2 bg-white/15 rounded-full overflow-hidden"><div className="h-full bg-[#f59321] rounded-full" style={{ width: `${job.total_stops ? (job.completed_stops / job.total_stops) * 100 : 0}%` }} /></div>
            <span className="text-sm font-bold">{job.completed_stops || 0} / {job.total_stops || 0}</span>
          </div>
        </div>
      </section>

      <section className="container-518 py-5 space-y-3 max-w-2xl" data-testid="driver-stop-list">
        {stops.map((s) => {
          const m = STOP_STATUS_META[s.status] || STOP_STATUS_META.pending;
          const done = s.status === "delivered";
          return (
            <Link key={s.id} to={`/driver/deliveries/${jobId}/stop/${s.id}`} data-testid={`driver-stop-link-${s.stop_number}`}
              className="flex items-center gap-4 bg-white rounded-2xl border border-slate-200 p-4 active:bg-slate-50">
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center font-display font-extrabold shrink-0 ${done ? "bg-emerald-500 text-white" : "bg-[#0f2847] text-white"}`}>
                {done ? <CheckCircle2 className="w-6 h-6" /> : String(s.stop_number).padStart(2, "0")}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-bold text-[#0f2847] truncate">{s.recipient_name}</div>
                <div className="text-xs text-slate-500 truncate">{s.address_line_1}, {s.city}</div>
                <span className={`inline-block mt-1 px-2 py-0.5 rounded-full text-[10px] font-bold border ${m.cls}`}>{m.label}</span>
              </div>
              <ArrowRight className="w-5 h-5 text-[#f59321] shrink-0" />
            </Link>
          );
        })}
      </section>
    </div>
  );
}
